export const HEADER_VARIANTS = {
  FLOATING: 'floating', // no background color
  FIXED: 'fixed', // full width with background color
  NORMAL: 'normal', // max width and with background color
} as const;
